/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type appVsts_viewer$ref = any;
export type appVsts_QueryVariables = {||};
export type appVsts_QueryResponse = {|
  +viewer: ?{|
    +actualPersonId: ?string,
    +component: ?string,
    +$fragmentRefs: appVsts_viewer$ref,
  |}
|};
export type appVsts_Query = {|
  variables: appVsts_QueryVariables,
  response: appVsts_QueryResponse,
|};
*/


/*
query appVsts_Query {
  viewer {
    actualPersonId
    component(name: "app_vsts")
    ...appVsts_viewer
    id
  }
}

fragment appVsts_viewer on Viewer {
  id
  company {
    id
    vstsEnabled
    vstsAccount
    vstsEstimateField
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actualPersonId",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "name",
      "value": "app_vsts"
    }
  ],
  "kind": "ScalarField",
  "name": "component",
  "storageKey": "component(name:\"app_vsts\")"
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "appVsts_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "appVsts_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "appVsts_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "Company",
            "kind": "LinkedField",
            "name": "company",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vstsEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vstsAccount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "vstsEstimateField",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "appVsts_Query",
    "operationKind": "query",
    "text": "query appVsts_Query {\n  viewer {\n    actualPersonId\n    component(name: \"app_vsts\")\n    ...appVsts_viewer\n    id\n  }\n}\n\nfragment appVsts_viewer on Viewer {\n  id\n  company {\n    id\n    vstsEnabled\n    vstsAccount\n    vstsEstimateField\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'cbbd20786ff1dbe0be7f2bc5dfe171e8';

module.exports = node;
